import React from "react"

import { MusterheftExportOverlayView } from "./MusterheftExportOverlayView"
import { MusterheftExportOverlayModel } from "./model/useMusterheftExportOverlayModel"
import { useMusterheftExportOverlayViewModel } from "./model/useMusterheftExportOverlayViewModel"

export interface MusterheftExportOverlayProps
  extends MusterheftExportOverlayModel {}

export const MusterheftExportOverlay = React.memo(
  (props: MusterheftExportOverlayProps) => (
    <MusterheftExportOverlayView
      {...useMusterheftExportOverlayViewModel(props)}
    />
  )
)
